/* eslint-disable */
import React from 'react';
import { ThemeContext } from './ThemeProviderWithFonts';
import { ErrorReporting } from '../base/errorHandling/ErrorReporting';
import { baseUnit } from '../theming/baseUnitDefinition';

export const useTheme = <T extends object>(key?: string): T => {
  const reporter = React.useContext(ErrorReporting);
  const themeContext = React.useContext(ThemeContext);

  if (key && themeContext[key] || !key) {
    return {
      ...(key && themeContext[key]),
      fontSizesStyles: themeContext.fontSizesStyles,
      baseUnit,
    };
  }

  reporter.reportWarning(`cannot find key: ${key} in configuration`);
  return {} as T;
};
